import React from 'react';
import PropTypes from 'prop-types';
import { IcepackFillerForm } from '../icepack-filler-form';
import { SimpleTableComponent } from '../../../../components/simple-table';
import { ICEPACK_FILLER_TABLE_COLUMNS_NAMES } from '../../constants';

export const IcepackFillerModalContent = ({ isLoading, icepackFillerInfo, isIcepackFillerFormOpen }) => {
	if (isIcepackFillerFormOpen) {
		return <IcepackFillerForm isLoading={isLoading} />;
	}

	return (
		<SimpleTableComponent
			rows={icepackFillerInfo}
			isTableDataLoading={isLoading}
			columns={ICEPACK_FILLER_TABLE_COLUMNS_NAMES}
			withOutMinHeight
		/>
	);
};

IcepackFillerModalContent.propTypes = {
	isLoading: PropTypes.bool.isRequired,
	icepackFillerInfo: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.shape({
					name: PropTypes.string,
					role: PropTypes.string,
				}),
			]).isRequired,
		}),
	),
	isIcepackFillerFormOpen: PropTypes.bool.isRequired,
};
